import axios from 'axios';
import { serialize } from 'object-to-formdata';

const pathBasMicrosite = '/microsite';
const pathConnect = '/app/connect';
const pathVacancy_ = '/app/vacancies';

const options = {
  indices: true
};

export function createPostulant(data) {
  return axios.post(`/api/postulations/save`, serialize(data, options));
}

export function updatePostulant(data) {
  return axios.post(`/api/postulations/edit`, serialize(data, options));
}

export function saveAttachedFile(data) {
  return axios.post(`${pathVacancy_}/saveAttachedFile`, serialize(data));
}

export function getLoginPortalExternal(data) {
  return axios.post(`${pathBasMicrosite}/postulacion/userLogin`, data);
}

export function getPostulant(data) {
  return axios.post(`${pathBasMicrosite}/postulacion/getPostulant`, data);
}

export function getAreaEstudio() {
  return axios.get(`${pathConnect}/getAreaEstudio`);
}

export function getStudyStatus() {
  return axios.get(`${pathConnect}/getStudyStatus`);
}

export function getStudyLevels() {
  return axios.get(`${pathConnect}/getStudyLevels`);
}

export function getInstitutions(countryId) {
  return axios.get(`${pathConnect}/getInstitutions/${countryId}`);
}

export function getSeniorities() {
  return axios.get(`${pathConnect}/getSeniorities`);
}

export function getIndustries() {
  return axios.get(`${pathConnect}/getIndustries`);
}

export function getBunAreas() {
  return axios.get(`${pathConnect}/getBunAreas`);
}

export function getBunSubAreas() {
  return axios.get(`${pathConnect}/getBunSubAreas`);
}

export function createBumeranPerfil(paramsData) {
  return axios.post(`${pathConnect}/createPostulBumAccount`, serialize(paramsData));
}

export function postPostulantEmailExist(mail, vacancyId, aliasAccount) {
  return axios.post(
    `/app/vacancies/isPostulanExistsForm`,
    serialize({
      email: mail,
      vacancy_id: vacancyId,
      alias_account: aliasAccount,
      is_update: true
    })
  );
}

export function sendSupport(name, email, subject, desc, link, account) {
  const data = { name, email, subject, desc, link, account };
  return axios.post(`/app/vacancies/sendSupport`, serialize(data));
}

export function postPostulantEmailSend(mail, aliasAccount) {
  return axios.post(
    `/app/vacancies/sendUpdateFromForm/`,
    serialize({
      email: mail,
      account: aliasAccount
    })
  );
}

export function getPostulantData(data) {
  return axios.post(`${pathBasMicrosite}/postulacion/postulant/getPostulant`, serialize(data));
}

export function isPostulanExists(data) {
  return axios.post(`/app/vacancies/postulantExists`, serialize(data));
}
